import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  passwordForm: FormGroup;
  shows:boolean = false;
  showBottom:boolean = false;
  showOldPassword:boolean = false;
  SUPERSECRET : any = environment.SUPERSECRET;
  passwordHas:any;
  encryptedPassword:any;
  passwordHasOther:any;
  encryptedPasswordOther:any;

  // Minimum eight characters, at least one letter, one number and one special character:
  passwordPattern = "(?=.*?[0-9])(?=.*?[#?/!@$%^&*-]).{8,}$";

  constructor(private formBuilder: FormBuilder,private router : Router,private service : AuthService) {
    this.passwordForm = this.formBuilder.group({
      newPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
      confirmPassword: ['', Validators.required],
      oldPassword: ['', Validators.required],
    }, { validator: this.passwordMatchValidator() });
   }

  ngOnInit(): void {
  }

  savePassowrd(){
    this.encryptPassword();
    let body = {
      newPassword: this.passwordHas,
      oldPassword: this.passwordHasOther,
    };
    console.log(body);
    this.service.resetPassword(body).subscribe((res:any)=>{
      if(res){
        sessionStorage.setItem("isPasswordChange", "true");
        Swal.fire({  
          icon: 'success',  
          title: 'Saved!',  
          text: 'Password updated successfully!',  
        }) 
        this.router.navigate(['/login/detailed-register'])
      }
      else {
        return 
      }
    },((err:any)=>{
      console.log(err);
      Swal.fire("Error", `${err.error.message}`, 'error');
    }))
  }

  password() {
    this.shows = !this.shows;
  }

  passwordBottom() {
    this.showBottom = !this.showBottom;
  }

  passwordOld() {
    this.showOldPassword = !this.showOldPassword;
  }

  passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const newPassword = control.get('newPassword')!;
      const confirmPassword = control.get('confirmPassword')!;
      return newPassword.value === confirmPassword.value ? null : { passwordMismatch: true };
    };
  }
 
  encryptPassword(){
    this.passwordHas = CryptoJS.HmacSHA256(this.passwordForm.value.newPassword.trim(),this.SUPERSECRET).toString();
    this.passwordHasOther = CryptoJS.HmacSHA256(this.passwordForm.value.oldPassword.trim(),this.SUPERSECRET).toString();
    
  }
}
